import { CONNECTION_TYPE } from 'types'

import { ReactComponent as AxosLogo } from 'assets/icons/AXOS.svg'
import { ReactComponent as FidelityLogo } from 'assets/icons/FIDELITY.svg'
import { ReactComponent as SchwabLogo } from 'assets/icons/SCHWAB.svg'
import { FlexBox, Text } from 'components/common'
import { old_COLOR } from 'styles/constants/old_color'
import { old_FONT_SIZE } from 'styles/constants/old_fontSize'
import { old_SPACE } from 'styles/constants/old_space'

type Props = {
  connectionType?: CONNECTION_TYPE
}

function ManagementOrganizationAccountCustodian({ connectionType }: Props) {
  let logo = null
  let connectionName = 'Unknown'
  switch (connectionType) {
    case CONNECTION_TYPE.SCHWAB:
      logo = <SchwabLogo />
      connectionName = 'Schwab RIA'
      break
    case CONNECTION_TYPE.FIDELITY:
      logo = <FidelityLogo width={20} height={20} />
      connectionName = 'Fidelity RIA'
      break
    case CONNECTION_TYPE.AXOS:
      connectionName = 'Axos RIA'
      logo = <AxosLogo width={20} height={20} />
      break
  }
  return (
    <FlexBox alignItems="center" gap={old_SPACE.sp8}>
      {logo}
      <Text
        color={old_COLOR.coolGray600}
        fontSize={old_FONT_SIZE.fs12}
        fontWeight="400"
      >
        {connectionName}
      </Text>
    </FlexBox>
  )
}

export default ManagementOrganizationAccountCustodian
